/* eslint-disable */
export default class ProceduralCheck{
    constructor(vid, parent) {
        this.vid = vid
        this.parent = parent
        this.sign = 'none'
        this.lastSign = 'none'
        this.init()

        this.handAngle = {
          thumb: {
            i: 0,
            j: 0,
          },
          index: {
            i: 0,
            j: 0,
            k: 0
          },
          middle: {
            i: 0,
            j: 0,
            k: 0
          },
          ring: {
            i: 0,
            j: 0,
            k: 0
          },
          pinky: {
            i: 0,
            j: 0,
            k: 0
          }
        }
    }
    init(){ 
      // this.getPos()
    }

   getPos(pos){

    // let elsMiddle = pos.middleFinger
    // this.middleFinger = Math.sqrt(Math.pow(elsMiddle[elsMiddle.length -1][0] - elsMiddle[0][0], 2) + Math.pow(elsMiddle[elsMiddle.length -1][1] - elsMiddle[0][1], 2))

    // let elsPinky = pos.pinky
    // this.pinkyFinger = Math.sqrt(Math.pow(elsPinky[elsPinky.length -1][0] - elsPinky[0][0], 2) + Math.pow(elsPinky[elsPinky.length -1][1] - elsPinky[0][1], 2))

    // let elsIndex = pos.indexFinger
    // this.indexFinger = Math.sqrt(Math.pow(elsIndex[elsIndex.length -1][0] - elsIndex[0][0], 2) + Math.pow(elsIndex[elsIndex.length -1][1] - elsIndex[0][1], 2))

    // let elsRing= pos.ringFinger
    // this.ringFinger = Math.sqrt(Math.pow(elsRing[elsRing.length -1][0] - elsRing[0][0], 2) + Math.pow(elsRing[elsRing.length -1][1] - elsRing[0][1], 2))
    
    // this.middlePalm = Math.sqrt(Math.pow(elsMiddle[elsMiddle.length -1][0] - pos.palmBase[0][0], 2) + Math.pow(elsMiddle[elsMiddle.length -1][1] - pos.palmBase[0][1], 2)) -  Math.sqrt(Math.pow(elsMiddle[0][0] - pos.palmBase[0][0], 2) + Math.pow(elsMiddle[0][1] - pos.palmBase[0][1], 2))
    // this.pinkyPalm = Math.sqrt(Math.pow(elsPinky[elsPinky.length -1][0] - pos.palmBase[0][0], 2) + Math.pow(elsPinky[elsPinky.length -1][1] - pos.palmBase[0][1], 2)) -  Math.sqrt(Math.pow(elsPinky[0][0] - pos.palmBase[0][0], 2) + Math.pow(elsPinky[0][1] - pos.palmBase[0][1], 2))
    // this.indexPalm = Math.sqrt(Math.pow(elsIndex[elsIndex.length -1][0] - pos.palmBase[0][0], 2) + Math.pow(elsIndex[elsIndex.length -1][1] - pos.palmBase[0][1], 2)) -  Math.sqrt(Math.pow(elsIndex[0][0] - pos.palmBase[0][0], 2) + Math.pow(elsIndex[0][1] - pos.palmBase[0][1], 2))
    // this.ringPalm = Math.sqrt(Math.pow(elsRing[elsRing.length -1][0] - pos.palmBase[0][0], 2) + Math.pow(elsRing[elsRing.length -1][1] - pos.palmBase[0][1], 2)) -  Math.sqrt(Math.pow(elsRing[0][0] - pos.palmBase[0][0], 2) + Math.pow(elsRing[0][1] - pos.palmBase[0][1], 2))

    this.getSign()
    // console.log(pos)
    this.setAngles(pos)

   }

   

   getSign(){
    this.sign = ''

    // if(this.middleFinger > this.ringFinger *1.5){
    //   this.sign = 'scissors'
    // } else if(this.middlePalm < 0 && this.pinkyPalm < 0 && this.ringPalm < 0) {
    //   this.sign = 'rock'
    // }  else if(this.middlePalm > 0 && this.pinkyPalm > 0 && this.indexPalm > 0 && this.ringPalm > 0) {
    //   this.sign = 'paper'
    // } else {
    //   this.sign = 'none'
    // }

    if(this.handAngle.index.j >  150 && this.handAngle.middle.j > 150 && this.handAngle.ring.j > 150 && this.handAngle.pinky.j > 150) {
      this.sign = 'paper'
    } else if(this.handAngle.index.j >  150 && this.handAngle.middle.j > 150 && this.handAngle.ring.j < 150 && this.handAngle.pinky.j < 150){
      this.sign = 'scissors'
    } else if(this.handAngle.middle.j < 150 && this.handAngle.ring.j < 150 && this.handAngle.pinky.j < 150) {
      this.sign = 'rock'
    } else {
      this.sign = 'none'
    }
    if (this.sign !== this.lastSign) {
      this.parent._emitter.emit("signFound", this.sign)
    }
    this.lastSign = this.sign

   }

   setAngles(pos){
    this.handAngle = {
      // thumb: {
      //   i: this.get3DAngle(pos.palmBase[0], pos.thumb[0], pos.thumb[1] ),
      //   j: this.get3DAngle(pos.thumb[0], pos.thumb[1], pos.thumb[2] ),
      // },
      index: {
        i: this.get3DAngle(pos.palmBase[0], pos.indexFinger[0], pos.indexFinger[1] ),
        j: this.get3DAngle(pos.indexFinger[0], pos.indexFinger[1], pos.indexFinger[2] ),
        // k: this.get3DAngle(pos.indexFinger[1], pos.indexFinger[2], pos.indexFinger[3] ),
      },
      middle: {
        i: this.get3DAngle(pos.palmBase[0], pos.middleFinger[0], pos.middleFinger[1] ),
        j: this.get3DAngle(pos.middleFinger[0], pos.middleFinger[1], pos.middleFinger[2] ),
        // k: this.get3DAngle(pos.middleFinger[1], pos.middleFinger[2], pos.middleFinger[3] ),
      },
      ring: {
        i: this.get3DAngle(pos.palmBase[0], pos.ringFinger[0], pos.ringFinger[1] ),
        j: this.get3DAngle(pos.ringFinger[0], pos.ringFinger[1], pos.ringFinger[2] ),
        // k: this.get3DAngle(pos.ringFinger[1], pos.ringFinger[2], pos.ringFinger[3] ),
      },
      pinky: {
        i: this.get3DAngle(pos.palmBase[0], pos.pinky[0], pos.pinky[1] ),
        j: this.get3DAngle(pos.pinky[0], pos.pinky[1], pos.pinky[2] ),
        // k: this.get3DAngle(pos.pinky[1], pos.pinky[2], pos.pinky[3] ),
      }
    }
   }

   getAngle(A,B,C) {
    var AB = Math.sqrt(Math.pow(B[0]-A[0],2)+ Math.pow(B[1]-A[1],2));    
    var BC = Math.sqrt(Math.pow(B[0]-C[0],2)+ Math.pow(B[1]-C[1],2)); 
    var AC = Math.sqrt(Math.pow(C[0]-A[0],2)+ Math.pow(C[1]-A[1],2));
    
    return Math.acos((BC*BC+AB*AB-AC*AC) / (2*BC*AB)) * (180 / Math.PI);   
  }

  get3DAngle(A, B, C){
    let v1 = [A[0] - B[0], A[1] - B[1], A[2] - B[2]]
    let v2 = [C[0] - B[0], C[1] - B[1], C[2] - B[2]]

    let v1mag = Math.sqrt(v1[0] * v1[0] + v1[1] * v1[1] + v1[2] * v1[2])
    let v1norm = [v1[0] / v1mag, v1[1] / v1mag, v1[2] / v1mag]

    let v2mag = Math.sqrt(v2[0] * v2[0] + v2[1] * v2[1] + v2[2] * v2[2])
    let v2norm = [v2[0] / v2mag, v2[1] / v2mag, v2[2] / v2mag]

    let res = v1norm[0] * v2norm[0] + v1norm[1] * v2norm[1] + v1norm[2] * v2norm[2]
    return Math.acos(res) * 180/Math.PI
  }

}